export type ApiError = Error & {
  fieldErrors?: string[];
  status?: number;
};

function buildJsonHeaders(init: RequestInit) {
  const headers = new Headers(init.headers || undefined);
  const hasBody = init.body !== undefined && init.body !== null;
  const isFormData = typeof FormData !== "undefined" && init.body instanceof FormData;
  const isUrlSearchParams =
    typeof URLSearchParams !== "undefined" && init.body instanceof URLSearchParams;
  const isBlob = typeof Blob !== "undefined" && init.body instanceof Blob;

  if (hasBody && !headers.has("Content-Type") && !isFormData && !isUrlSearchParams && !isBlob) {
    headers.set("Content-Type", "application/json");
  }

  return headers;
}

function createApiError(message: string, status: number, fieldErrors: string[] = []) {
  const error = new Error(message) as ApiError;
  error.fieldErrors = fieldErrors;
  error.status = status;
  return error;
}

export async function fetchJson<T>(url: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(url, {
    ...init,
    headers: buildJsonHeaders(init),
  });

  const responseText = await response.text();
  let payload: (T & { error?: string; detail?: string; field_errors?: string[] }) | null = null;
  if (responseText.trim()) {
    try {
      payload = JSON.parse(responseText) as T & { error?: string; detail?: string; field_errors?: string[] };
    } catch (error) {
      if (!response.ok) {
        throw createApiError("Erreur serveur. La réponse de l’API n’est pas lisible.", response.status);
      }
      throw error;
    }
  }

  if (!response.ok) {
    throw createApiError(payload?.error || payload?.detail || "Erreur serveur", response.status, payload?.field_errors || []);
  }

  return payload as T;
}
